import { render } from "./ApprovalsListCardHistoryCta.vue?vue&type=template&id=0eb1eb60"
import script from "./ApprovalsListCardHistoryCta.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardHistoryCta.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__